import type { IVariable } from '@carboncopyco/types';
import { TextBoxEditorTitle } from '@carboncopyco/ui';
import { useMemo, useState } from 'react';
import { SearchBoxInput } from '../SearchBoxInput';
import { SearchItems, type SearchItemsProps } from './SearchItems';

export interface VariablesSearchProps<T extends IVariable>
  extends Pick<SearchItemsProps<T>, 'onSelect'> {
  variables: T[];
  title?: string;
}

export const VariablesSearch = <T extends IVariable>({
  title = 'Replace with variable',
  variables,
  onSelect,
}: VariablesSearchProps<T>) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const filteredVariables = useMemo(
    () => variables.filter((variale) => variale.name.includes(searchValue)),
    [searchValue, variables]
  );

  return (
    <div className="flex flex-col gap-2 pt-3 pb-2 w-[254px]">
      <div className="flex flex-col gap-3 px-4 text-start">
        <TextBoxEditorTitle
          label={title}
          uppercase
        />
        <SearchBoxInput
          value={searchValue}
          onChange={setSearchValue}
        />
      </div>
      <div className="px-2">
        <SearchItems
          variables={filteredVariables}
          onSelect={onSelect}
        />
      </div>
    </div>
  );
};
